(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ConfigDialogController", ConfigDialogController);

    ConfigDialogController.$inject = [
        "$state",
        "$stateParams",
        "ConfigSave",
        "ConfigUpdate",
        "Configs",
        "AlertService"
    ];

    function ConfigDialogController($state, $stateParams, ConfigSave, ConfigUpdate, Configs, AlertService) {
        var vm = this;
        vm.config = {};
        vm.save = save;
        vm.clear = clear;

        if ($stateParams.id) {
            Configs.get({ id: $stateParams.id }, function (result) {
                vm.config = result;
            });
        }

        function clear() {
            $state.go("config", null, { reload: true });
        }

        function save() {
            if (vm.config.id) {
                ConfigUpdate.update(vm.config, onSaveSuccess, onSaveError);
            } else {
                ConfigSave.save(vm.config, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            AlertService.success("Configuration saved successfully!");
            $state.go("config", null, { reload: true });
        }

        function onSaveError(error) {
            AlertService.error(error.data.message);
        }
    }
})();
